import { useSelector } from 'react-redux';

export const useAppName = () => {
  return useSelector((state) => state?.applicationState?.nombre || '');
};

export const getAppNameFromStore = (state) => state?.applicationState?.nombre || '';


